<template v-if="prep_process.id">
  <info-header-card :header="header" :rows="rows"></info-header-card>
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import PrepProcessModel from "@/models/lab/PrepProcessModel";

export default {
  name: "PrepProcessCard",
  components: {
    InfoHeaderCard
  },
  props: {
    prep_process: {
      type: Object,
      default: () => new PrepProcessModel()
    }
  },
  computed: {
    header() {
      return this.prep_process.name;
    },
    rows() {
      const sample_types = this.prep_process.getSampleTypes();
      const sample_type_names = sample_types.models.length
        ? sample_types.models
            .map(({ name }) => name)
            .sort()
            .join(", ")
        : null;

      return [
        {
          label: "Sample Types",
          value: sample_type_names
        },
        {
          label: "Description",
          value: this.prep_process.description
        }
      ];
    }
  }
};
</script>
